import type { IconSvgObject } from './types';

const SustainableEnergyIcon: IconSvgObject = [
  ["path", { d: "M13.5 21.3822C13.0114 21.4597 12.5104 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 8.58788 4.29888 5.67516 7 3.99997M17 20C19.6311 18.3107 21.5 15.3589 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C11.4896 2.5 10.9886 2.54025 10.5 2.61775M17 20V17M17 20L20.5 20M7 3.99997V6.99997M7 3.99997H3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.5 7L9 12H15L11.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SustainableEnergyIcon;
